import { Navigate } from 'react-router-dom';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { OrphanAccountRedirect } from '#client/components/OrphanAccountRedirect';
import { SHOW_ORPHAN_ACCOUNT_OPTIONS } from '#client/constants/experimentsFlags';
import * as ROUTES from '#client/constants/routes';
import { useOrderTrackerStatus } from '#client/hooks/useOrderTrackerStatus';

import Home from './Home';

const HomeRenderer = () => {
  const { orderTasksWithStatus, loading } = useOrderTrackerStatus();
  const orphanedAccountOptionsEnabled = useExperimentFlag(SHOW_ORPHAN_ACCOUNT_OPTIONS, false);

  // Redirect only if user has no order tasks
  const shouldRedirectOrphanAccount = !loading && orderTasksWithStatus?.length === 0;

  if (shouldRedirectOrphanAccount && orphanedAccountOptionsEnabled) {
    return <Navigate to={ROUTES.getStarted} replace />;
  }

  if (shouldRedirectOrphanAccount && !orphanedAccountOptionsEnabled) {
    return <OrphanAccountRedirect />;
  }

  return <Home loading={loading} />;
};

export default HomeRenderer;
